__turbopack_context__.v({
  "icon": "k06a1W_icon",
});
